export default "__VITE_ASSET__Bgp1BtIO__"